import { supabase } from '@/lib/supabase';

/**
 * Mirror a theme selection to the user's profile so it follows them across
 * devices. The shared `profiles` table already has a `skin_id` column (the OG's
 * theme field, supabase.js:238) — we reuse it rather than adding a migration.
 *
 * Best-effort: localStorage is the instant-boot source of truth; this is a
 * convenience sync, so a failure is logged, never thrown.
 */
export async function saveThemePreference(userId: string, themeId: string): Promise<void> {
  // The custom upload is a per-device data URL — never persisted server-side.
  if (themeId === 'custom') return;
  const { error } = await supabase.from('profiles').update({ skin_id: themeId }).eq('id', userId);
  if (error) console.warn('saveThemePreference failed:', error.message);
}
